import { useQuery, useQueryClient } from "@tanstack/react-query";
import { floorAlarmsApi, type FloorAlarmRow } from "@/lib/api/client";
import { applyFloorAlarmEvent, FLOOR_ALARM_EVENT, FLOOR_ALARMS_KEY, floorAlarmsPollInterval } from "@/lib/floor-alarms";
import { RECONNECT_EVENT, usePortalEvent } from "@/lib/portal-socket";

/** Alarm state of every floor the member may see on the floor plans.
 *
 *  Pushed: `floor_alarm_changed` on the portal socket updates the cache at
 *  once (older pushes are dropped by `seq`). A reconnect refetches; a 5 min
 *  refetch runs only while a visible floor has an alarm linked. */
export function useFloorAlarms(): FloorAlarmRow[] | undefined {
  const qc = useQueryClient();
  const { data, refetch } = useQuery({
    queryKey: FLOOR_ALARMS_KEY,
    queryFn: () => floorAlarmsApi.list().then((r) => r.data),
    refetchInterval: (query) => floorAlarmsPollInterval(query.state.data),
    staleTime: 60_000,
  });
  usePortalEvent(FLOOR_ALARM_EVENT, (event) => {
    qc.setQueryData<FloorAlarmRow[]>(FLOOR_ALARMS_KEY, (rows) => applyFloorAlarmEvent(rows, event));
  });
  usePortalEvent(RECONNECT_EVENT, () => {
    void refetch();
  });
  return data;
}
